import { FiAward, FiStar, FiTarget } from "react-icons/fi";
import AvatarImg from "../../../../../assets/images/avatar.png";

const LeaderBoardSection = () => {
  const leaderboard = [
    { rank: 1, name: "Alex Chen", wins: 12, points: 2847 },
    { rank: 2, name: "Sarah Kim", wins: 10, points: 2756 },
    { rank: 3, name: "Mike Rodriguez", wins: 9, points: 2698 },
    { rank: 4, name: "Emma Johnson", wins: 8, points: 2634 },
    { rank: 5, name: "David Wilson", wins: 7, points: 2587 },
  ];

  const achievements = [
    { title: "First Victory", desc: "Win your first tournament", percent: 100 },
    {
      title: "Speed Demon",
      desc: "Solve 3 problems in under 30 minutes",
      percent: 67,
    },
    {
      title: "Consistency King",
      desc: "Participate in 10 consecutive tournaments",
      percent: 80,
    },
    {
      title: "Problem Solver",
      desc: "Solve 100 tournament problems",
      percent: 45,
    },
  ];

  return (
    <section className="row mx-0 py-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        {/* Leaderboard */}
        <div className="row mx-0">
          <div className="col-md-6 mb-4">
            <div className="rounded-lg border shadow-sm bg-dark-secondary border-primary">
              <div className="p-4">
                <h4 className="text-light fw-bold mb-4 d-flex align-items-center">
                  <FiAward className="text-accent me-2" /> Global Leaderboard
                </h4>
                {leaderboard.map((player) => (
                  <div
                    key={player.rank}
                    className="d-flex align-items-center p-3 mb-2 bg-dark rounded hover-card"
                  >
                    <span className="badge bg-primary me-3">
                      #{player.rank}
                    </span>
                    <img
                      src={AvatarImg}
                      alt="Avatar"
                      className="rounded-circle me-3"
                      width="32"
                      height="32"
                    />
                    <div className="flex-grow-1">
                      <div className="text-light fw-medium">{player.name}</div>
                      <small className="text-muted-custom">
                        {player.wins} wins
                      </small>
                    </div>
                    <div className="text-end">
                      <div className="text-primary fw-bold">
                        {player.points}
                      </div>
                      <small className="text-muted">points</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Achievements */}
          <div className="col-md-6">
            <div className="rounded-lg border shadow-sm bg-dark-secondary border-primary">
              <div className="p-4">
                <h4 className="text-light fw-bold mb-4 d-flex align-items-center">
                  <FiStar className="text-accent me-2" /> Achievements
                </h4>
                {achievements.map((ach, idx) => (
                  <div key={idx} className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <h6 className="text-light mb-1 d-flex align-items-center">
                          {idx === 0 && (
                            <FiTarget className="text-accent me-2" />
                          )}
                          {ach.title}
                        </h6>
                        <small className="text-muted">{ach.desc}</small>
                      </div>
                      <span className="text-primary fw-bold">
                        {ach.percent}%
                      </span>
                    </div>
                    <div className="progress" style={{ height: "4px" }}>
                      <div
                        className={`progress-bar ${
                          ach.percent === 100 ? "bg-accent" : "bg-primary"
                        }`}
                        style={{ width: `${ach.percent}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeaderBoardSection;
